<template>
  <div>
    <header-bar>
      スプリット
    </header-bar>
    <div class="page-block page-feature">
      <div class="page-block__inner">
        <div class="text-alignment">
          <span class="title">
            スプリット申請完了
          </span><br />
          <span class="subtitle">
            「{{ $route.query.title }}」のスプリットの申請を受け付けました。
          </span>
        </div>
      </div>
      <div class="list-container">
        <ul>
          <li>管理者によるスプリットへの招待は、本日より1週間有効です。</li>
          <li>スプリットが確定、もしくはキャンセルされた場合、メールにてお知らせします。</li>
          <li>
            承認状況の確認や招待メールの再送信は
            「<router-link
              class="link"
              :to="$route.query.type === 'album'
                ? `/client/revenue-share/detail/album/${$route.query.id}`:
                  `/client/revenue-share/detail/${$route.query.id}`">
              スプリット詳細画面
            </router-link>」にて行うことができます。
          </li>
        </ul>
        <div class="c-btn-wrap">
          <a
            href="#"
            class="c-btn"
            @click.prevent="onClickSplitTop()">
            スプリットトップへ
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'RegistrationCompletion',
  components: {
    HeaderBar,
  },
  methods: {
    onClickSplitTop() {
      window.sessionStorage.removeItem('split')
      this.$router.push({ name: 'revenue-share' })
    },
  },
}
</script>

<style scoped>

.text-alignment {
  text-align: center;
  font-weight: 400;
}

.page-feature div {
  padding: 10px 30px;
}

.page-feature ul, .page-feature li {
  list-style: unset !important;
}

.page-feature {
    min-width: 1120px;
    max-width: 1120px;
    margin-bottom: 229.33px;
}

.title {
  color: #ff2289;
  font-size: 25px;
  font-weight: bold;
}
.subtitle {
  font-size: 22px;
}
.list-container {
  margin: 0 20%;
}
.link {
  color: #1976d2;
  text-decoration: underline;
}
.link:hover {
  color: #1976d2;
  text-decoration: underline;
}
</style>
